<template>
  <div class="transaction">
    <Header :mainHeader="true" />

    <section id="transaction-products" style="padding: 10px 0px !important">
      <div class="containers">
        <h5 class="fw-bold">
          Insurance Management<button
            class="pull-right btn btn-primary"
            style="float: right; margin: 10px"
            @click="openModal"
          >
            Add Insurance
          </button>
        </h5>
        <div class="modal-container" style="width: 50%" v-if="showAddModal">
          <h5 class="p-20">Add Insurance</h5>
          <hr />

          <div class="p-30">
            <label for="">Insurance Code</label>
            <input
              type="text"
              name="code"
              v-model="code"
              class="form-control"
              style="background: #fff; border: 1px solid #000"
            />

            <label for="">Insurance Name</label>
            <input
              type="text"
              name="name"
              v-model="name"
              class="form-control"
              style="background: #fff; border: 1px solid #000"
            />

            <label for="">Premium Rate</label>
            <input
              type="number"
              min="0"
              max="100"
              name="rate"
              v-model="rate"
              class="form-control"
              style="background: #fff; border: 1px solid #000"
            />
            <div class="w-100">
              <div class="w-50 d-inline-block pe-3">
                <button
                  class="btn-style full d-flex justify-content-center"
                  @click="postInsurance"
                  style="margin-top: 10px"
                >
                  <div
                    v-if="loading"
                    class="spinner-border text-light text-sm mr-4 mb-1"
                    role="status"
                    style="margin-right: 10px"
                  ></div>
                  Add Insurance
                </button>
              </div>
              <div class="w-50 d-inline-block ps-3">
                <button
                  class="btn-style full d-flex justify-content-center insurance-close"
                  @click="closeModal()"
                  style="margin-top: 10px"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container" v-if="!showAddModal">
          <table class="table table-hover" id="insurancesTable">
            <thead>
              <tr>
                <th>No</th>
                <th>Insurance Code</th>
                <th>Insurance Name</th>
                <th>Premium Rate</th>
              </tr>
            </thead>
            <!--
                    <tbody v-if="insurances">
                        <tr v-for="(insurance,index) in insurances" v-bind:key="insurance.id">
                            <td>{{ index+1 }}</td>
                            <td>{{ insurance.isrccCd }}</td>
                            <td>{{ insurance.isrccNm }}</td>
                            <td>{{ insurance.isrcRt }}</td>
                        </tr>
                         Add more rows as needed 
                    </tbody>
                    <p v-else>No Insurances found</p>-->
          </table>
          <LoaderItem v-if="loading" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Swal from "sweetalert2";
import "datatables.net-vue3";
import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import $ from "jquery";
//import 'jszip';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.print.js";
import { formatDate } from "@/utils/commons";
import LoaderItem from "@/components/LoaderItem.vue";

export default {
  name: "InsurancePage",
  components: {
    Header,
    LoaderItem,
  },
  data() {
    return {
      token: JSON.parse(localStorage.getItem("access_token")),
      insurances: [],
      showAddModal: false,
      processedData: [],
      name: "",
      code: "",
      rate: "",
      addInsurance: "none",
      loading: false,
    };
  },
  methods: {
    openModal() {
      this.showAddModal = true;
    },
    closeModal() {
      this.showAddModal = false;
      this.getInsurances();
    },

    preprocessData(rawData) {
      return rawData.map((item) => {
        return {
          indexNo: "1",
          insuranceCode: item.isrccCd,
          insuranceName: item.isrccNm,
          premiumRate: item.isrcRt,
        };
      });
    },

    initializeDataTable() {
      try {
        this.dataTable = $(this.$el)
          .find("#insurancesTable")
          .DataTable({
            responsive: true,
            language: {
              paginate: {
                previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
              },
            },
            dom: '<"datatable-buttons"B><"datatable-search"f>tip',
            buttons: [
              {
                extend: "colvis",
                text: "Column Visibility",
                className: "btn-grey",
              },
              {
                extend: "pageLength",
                text: "Page Length",
                className: "btn-grey",
              },
              {
                extend: "csv",
                text: "Export CSV",
                className: "btn-grey",
                exportOptions: {
                  columns: ":visible",
                },
              },
              {
                extend: "pdfHtml5",
                text: "Export PDF",
                orientation: "landscape",
                className: "btn-grey",
                exportOptions: {
                  columns: ":visible",
                },
                customize: this.customizePDF,
              },
            ],
            data: this.processedData,
            columns: [
              { data: null },
              { data: "insuranceCode" },
              { data: "insuranceName" },
              { data: "premiumRate" },
            ],
            columnDefs: [
              {
                targets: 0,
                searchable: false,
                orderable: false,
                render: (data, type, row, meta) => {
                  return meta.row + 1;
                },
              },
            ],
          });
      } catch (error) {
        console.log({ error });
      }
    },

    customizePDF(doc) {
      //const logoBase64 = this.convertToBase64(logo)
      //console.log(logoBase64)
      doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
      doc.defaultStyle.columnGap = 0;
      doc.content[1].fillColor = "#f2f2f2";

      (doc.header = () => {
        return {
          columns: [
            {
              width: "*",
              columns: [
                /* {
                        image: logoBase64,
                        width: 150, // Adjust the width as needed
                    },*/
                {
                  text: "Taxpoint",
                  alignment: "left",
                  margin: [40, 15, 0, 40], // Adjust margins as needed
                  color: "#000", // Orange color
                  bold: true,
                  fontSize: 14,
                },
              ],
            },
            {
              width: "*",
              stack: [
                {
                  text: "Products List",
                  alignment: "right",
                  margin: [0, 15, 50, 0],
                  fontSize: 12,
                  color: "#4448B3",
                },
                {
                  alignment: "right",
                  margin: [300, 0, 0, 0],
                  width: "*",
                  columns: [
                    {
                      width: "auto",
                      text: "Date:",
                      alignment: "right",
                      margin: [0, 0, 10, 0],
                      bold: true,
                    },
                    {
                      width: "auto",
                      text: `${formatDate(new Date(), "true")}`,
                      alignment: "right",
                      margin: [0, 0, 50, 0],
                      fontSize: 9,
                    },
                  ],
                },
              ],
            },
          ],
          fillColor: "#000000",
        };
      }),
        (doc.footer = (currentPage, pageCount) => {
          return {
            columns: [
              { width: "*", text: "www.pavicongroup.co.ke", alignment: "left" },
              {
                width: "*",
                text: "contact@pavicongroup.co.ke",
                alignment: "center",
              },
              {
                width: "*",
                text: `Page ${currentPage} of ${pageCount}`,
                alignment: "center",
              },
              {
                width: "*",
                text: `Printed on ${formatDate(new Date(), "true")}`,
                alignment: "right",
              },
            ],
            margin: [40, 10, 40, 10], // Margin for the whole footer
            fillColor: "black",
          };
        });

      doc.styles.title = {
        color: "#4448B3",
        fontSize: 13,
        margin: [80, 0, 0, 40],
      };
    },

    async getInsurances() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      try {
        this.loading = true;
        const res = await fetch(
          process.env.VUE_APP_URL + "/insurance",
          requestOptions
        );
        const data = await res.json();

        if (data.status === true) {
          this.insurances = data.insurances;
          this.processedData = this.preprocessData(this.insurances);
          this.initializeDataTable();
        } else {
          Swal.fire({
            icon: "error",
            title: "Insurances not found",
            text: data.message,
          });
        }
      } catch (error) {
        // Handle network errors or JSON parsing errors
        //console.error('Error fetching or parsing data:', error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch insurance data. Please try again later.",
        });
      } finally {
        this.loading = false;
      }
    },

    async postInsurance() {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
        body: JSON.stringify({
          isrccCd: this.code,
          isrccNm: this.name,
          isrcRt: this.rate,
          useYn: "Y",
        }),
      };

      const res = await fetch(
        process.env.VUE_APP_URL + "/insurance",
        requestOptions
      );
      const data = await res.json();
      if (data.status == true) {
        Swal.fire({
          icon: "success",
          title: "Insurance created Successful",
          text: data.message,
        });
        this.getInsurances();
        this.showAddModal = false;
        this.addInsurance = "none";
        this.rate = "";
        this.code = "";
        this.name = "";
      } else {
        Swal.fire({
          icon: "error",
          title: "Insurance not found",
          text: data.message,
        });
      }
    },
  },
  mounted() {
    this.getInsurances();
  },
};
</script>
